import React from 'react';
import { StarIcon } from 'base/components/Icon';
import RowActionButton from 'base/components/table/RowActionButton';
import theme from '../../../theme';
import FavoriteToggle from '../../containers/FavoriteToggle/FavoriteToggle';

const getFavoriteColumn = onClick => ({
  Header: <StarIcon color={theme.colors.medium} />,
  Cell: ({ original }) => (
    // eslint-disable-line

    <RowActionButton original={original} handleClick={onClick}>
      <FavoriteToggle document={original} color={theme.colors.medium} />
    </RowActionButton>
  ),

  sortable: false,
  width: 50,
});

export default getFavoriteColumn;
